/**
 * 商品页优惠价格模块
 * - 折后价计算与变体切换同步
 * - 优惠明细弹窗（data-deal-modal）
 * - 分期说明图片弹窗（data-installment-modal）
 */
(function () {
  // 防止脚本重复加载时重复绑定事件
  if (window.__productDealModalBound) return;
  window.__productDealModalBound = true;

  /** 从 DOM 中的 JSON script 节点解析数据 */
  function parseJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /** 获取主题货币格式，用于 formatMoney */
  function getMoneyFormat() {
    return window.theme && window.theme.settings && window.theme.settings.money_with_currency_format
      ? window.theme.settings.money_with_currency_format
      : '${{amount}}';
  }

  /** 将分（cents）格式化为货币字符串 */
  function formatCents(cents) {
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, getMoneyFormat());
    }
    return (cents / 100).toFixed(2);
  }

  /**
   * 根据集合 metafield 折扣规则计算折后价
   * @returns {{ finalPrice: number, showDeal: boolean, discountAmount: number }}
   */
  function calculateDeal(priceCents, rules) {
    var finalPrice = priceCents;
    var showDeal = false;

    if (!Array.isArray(rules) || !rules.length) {
      return { finalPrice: finalPrice, showDeal: showDeal, discountAmount: 0 };
    }

    rules.forEach(function (rule) {
      var threshold = Math.round(parseFloat(rule.threshold) * 100);
      var value = parseFloat(rule.value);
      if (!threshold || isNaN(value)) return;
      if (priceCents < threshold) return;

      var nextPrice = priceCents;
      if (rule.type === 'discount') {
        // 百分比折扣，如 10 表示打 9 折
        nextPrice = Math.round(priceCents * (100 - value) / 100);
      } else if (rule.type === 'reduction') {
        // 固定金额减免
        nextPrice = priceCents - Math.round(value * 100);
      } else {
        return;
      }

      // 取所有满足条件规则中的最低价
      if (!showDeal || nextPrice < finalPrice) {
        finalPrice = nextPrice;
        showDeal = true;
      }
    });

    if (finalPrice < 0) finalPrice = 0;

    return {
      finalPrice: finalPrice,
      showDeal: showDeal,
      discountAmount: priceCents - finalPrice
    };
  }

  /** 限定在当前 section 的 deal-price 容器内查找元素 */
  function getDealScope(sectionId) {
    if (sectionId) {
      var scoped = document.getElementById('deal-price-' + sectionId);
      if (scoped) return scoped;
    }
    return document;
  }

  /** 同步更新 4 期分期金额（折后价 ÷ 4） */
  function updateInstallment(sectionId, finalPriceCents) {
    var installmentEl = document.querySelector('#installment-price-' + sectionId + ' [data-deal-installment]');
    if (!installmentEl) return;
    var installmentCents = Math.round(finalPriceCents / 4);
    installmentEl.textContent = formatCents(installmentCents);
  }

  /** 变体切换后重新计算并渲染折后价、弹窗数据及分期金额 */
  function updateDealPrice(sectionId, variantId) {
    if (!variantId) return;

    var scope = getDealScope(sectionId);
    var root = scope.querySelector('[data-deal-root]');
    if (!root) return;

    var pricesEl = scope.querySelector('[data-deal-variant-prices]');
    var rulesEl = scope.querySelector('[data-deal-rules-json]');
    var prices = parseJson(pricesEl);
    var rules = parseJson(rulesEl) || [];
    var priceCents = prices ? prices[String(variantId)] : null;

    if (priceCents == null) return;

    var result = calculateDeal(priceCents, rules);
    var finalEl = root.querySelector('[data-deal-final]');
    var modal = scope.querySelector('[data-deal-modal]');
    var modalFinal = scope.querySelector('[data-deal-modal-final]');
    var modalCurrent = scope.querySelector('[data-deal-modal-current]');
    var modalDiscount = scope.querySelector('[data-deal-modal-discount]');

    if (!finalEl) return;

    var formattedFinal = formatCents(result.finalPrice);
    var formattedPrice = formatCents(priceCents);
    var formattedDiscount = formatCents(result.discountAmount);
    var infoBtnHtml = '<button type="button" class="product-deal__info" data-deal-open aria-label="Discount details"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75m-.004 4.5h.008v.008h-.008v-.008Z"/></svg></button>';

    if (result.showDeal) {
      // 有优惠时显示折后价 + 详情按钮，并更新弹窗内各字段
      finalEl.innerHTML = formattedFinal + infoBtnHtml;
      if (modal) {
        modal.hidden = true;
        if (modalFinal) modalFinal.textContent = formattedFinal;
        if (modalCurrent) modalCurrent.textContent = '=' + formattedPrice;
        if (modalDiscount) modalDiscount.textContent = '-' + formattedDiscount;
      }
    } else {
      finalEl.textContent = formattedFinal;
      if (modal) modal.hidden = true;
    }

    updateInstallment(sectionId, result.finalPrice);
  }

  /** 清理 quick-view 挂到 body 上的旧弹窗，避免重复 id */
  function removeQuickViewInstallmentModals() {
    document.querySelectorAll('[data-installment-modal][data-installment-in-quick-view]').forEach(function (modal) {
      modal.remove();
    });
  }

  /** 打开分期说明图片弹窗（main-product / quick-view 中 zipimg 配置） */
  function openInstallmentModal(opener) {
    var sectionEl = opener.closest('[id^="installment-price-"]');
    if (!sectionEl) return;
    var sectionId = sectionEl.id.replace('installment-price-', '');
    var drawerContent = opener.closest('#Product-Drawer-Content');
    var modalId = 'installment-modal-' + sectionId;
    var modal = document.getElementById(modalId);

    if (!modal && drawerContent) {
      modal = drawerContent.querySelector('#' + modalId);
    }
    if (!modal) return;

    // 快速购物抽屉带 transform，fixed 弹层需挂到 body 才能全屏显示
    if (drawerContent && modal.parentElement !== document.body) {
      modal.dataset.installmentInQuickView = 'true';
      document.body.appendChild(modal);
    }

    modal.hidden = false;
  }

  /** 关闭所有分期说明弹窗 */
  function closeInstallmentModals() {
    document.querySelectorAll('[data-installment-modal]:not([hidden])').forEach(function (modal) {
      modal.hidden = true;
    });
  }

  // 点击：打开/关闭优惠弹窗与分期图片弹窗
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-deal-open]');
    if (opener) {
      e.preventDefault();
      var scope = opener.closest('.product-price-container') || document;
      var modal = scope.querySelector('[data-deal-modal]');
      if (modal) modal.hidden = false;
      return;
    }
    var installmentOpener = e.target.closest('[data-installment-open]');
    if (installmentOpener) {
      e.preventDefault();
      openInstallmentModal(installmentOpener);
      return;
    }
    if (e.target.closest('[data-deal-close]')) {
      var m = e.target.closest('[data-deal-modal]');
      if (m) m.hidden = true;
    }
    if (e.target.closest('[data-installment-close]')) {
      var im = e.target.closest('[data-installment-modal]');
      if (im) im.hidden = true;
    }
    if (e.target.closest('.click-capture--product') || e.target.closest('.side-panel-close')) {
      closeInstallmentModals();
      removeQuickViewInstallmentModals();
    }
  });

  // 键盘：Enter/Space 打开分期弹窗，Escape 关闭所有弹窗
  document.addEventListener('keydown', function (e) {
    if (e.target.closest('[data-installment-open]') && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      openInstallmentModal(e.target.closest('[data-installment-open]'));
      return;
    }
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-deal-modal]:not([hidden])').forEach(function (m) {
        m.hidden = true;
      });
      closeInstallmentModals();
    }
  });

  // 监听变体切换事件，同步更新价格
  document.addEventListener('product:variant-updated', function (e) {
    if (!e.detail || !e.detail.variant) return;
    updateDealPrice(e.detail.sectionId, e.detail.variant.id);
  });
})();
